module.exports = __webpack_public_path__ + "assets/d5c68afa58ffbea644d166c22e984057.png";